import React from 'react';
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { OrderPageData } from '../../../api';
import { RelatedExperienceCard } from './RelatedExperienceCard';

interface RelatedExperiencesSectionProps {
  orderPages: OrderPageData[];
}

export const RelatedExperiencesSection = ({ orderPages }: RelatedExperiencesSectionProps) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  if (orderPages.length === 0) {
    return null;
  }

  return (
    <Box sx={{ marginBottom: isSmallScreen ? 4 : 5 }}>
      <Typography variant="h6" sx={{ fontWeight: 600, marginBottom: 1.5 }}>
        {t('experiencePage.relatedExperiences')}
      </Typography>

      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: isSmallScreen ? '1fr' : 'repeat(2, 1fr)',
          gap: 2,
        }}>
        {orderPages.map((orderPage) => (
          <RelatedExperienceCard key={orderPage.id} orderPage={orderPage} />
        ))}
      </Box>
    </Box>
  );
};
